import React from "react";
import styled from 'styled-components'
import Link from 'next/link'


const StoryTitle = styled.h1.attrs({
	className: "text-3xl lg:text-4xl text-center font-bold my-2"
})` font-family: ${props => props.theme.fonts.poppins}; `;


export default ({storySlug, noLink, children}) => {
	if (noLink) {
		return (
			<StoryTitle>
				{children}
			</StoryTitle>
		)
	} else {
		return (
			<Link href={`/${storySlug}`} passHref>
                <StoryTitle>
                    {children}
                </StoryTitle>
			</Link>
		)
	}
}
